export const getModalQuickAccessStatus = (state) =>
  state.modal_quick_access.active

export const getModalVerifyCodeStatus = (state) =>
  state.modal_verify_code.active